import Store from "@/models/loyaltyPanel/stores/Store";
import UserDetails from "@/models/loyaltyPanel/stores/UserDetails";

export default {
    namespaced: true,

    state: () => ({
        subscriptionPlans: [],
        countries: [],
        networkRegions: [],
        stores: [],
        store: new Store(),
        userDetails: new UserDetails(),
        financialData: [],
        newStoreCreated: false,
        permissions: {},
        storesDefaultPermissions: {},
        rightsDialog: false,
        exportedFile: null,

    }),

    mutations: {
        setSubscriptionPlans(state, payload) {
            state.subscriptionPlans = payload;
        },

        setRightsDialog(state, payload) {
            state.rightsDialog = payload;
        },

        setCountries(state, payload) {
            state.countries = payload;
        },

        setNetworkRegions(state, payload) {
            state.networkRegions = payload;
        },

        setItems(state, payload) {
            state.stores = payload;
        },

        setFinancialData(state, payload) {
            state.financialData = payload;
        },

        setItem(state, payload) {
            state.store = new Store(payload);
        },

        setUserDetails(state, payload) {
            state.userDetails = new UserDetails(payload);
        },

        addItem(state, payload) {
            state.stores.unshift(payload);
        },

        updateItem(state, payload) {
            let index = state.stores.findIndex(
                s => s.store_id === payload.store_id
            );
            state.stores.splice(index, 1, payload);
        },

        removeItem(state, id) {
            state.stores = state.stores.filter(s => s.store_id !== id);
        },

        setNewStoreCreated(state, payload) {
            state.newStoreCreated = payload
        },

        setStoresDefaultPermissions(state, payload) {
            state.storesDefaultPermissions = payload
        },

        setPermissions(state, payload) {
            state.permissions = payload
        },
        
        setExportedFile(state, payload){
            state.exportedFile = payload;
        },
    },

    actions: {
        async getSubscriptionPlans({ commit }) {
            try {
                const { data } = await Store.getSubscriptionPlans();

                commit("setSubscriptionPlans", data.data);
            } catch (ex) {
                console.error(ex.response.data.message);
            }
        },

        async getCountries({ commit }) {
            try {
                const { data } = await Store.getCountries();

                commit("setCountries", data.data);
            } catch (ex) {
                console.error(ex.response.data.message);
            }
        },

        async getNetworkRegions({ commit }) {
            try {
                const { data } = await Store.getNetworkRegions();

                commit("setNetworkRegions", data.data);
            } catch (ex) {
                console.error(ex.response.data.message);
            }
        },

        async getItems({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Store.get(query);

                const { stores, pagination } = data.data;
                stores.map(store => {
                    store.show_on_map = store.show_on_map == "true" ? true : false
                    store.online_payment_processing = store.online_payment_processing == "true" ? true : false
                    store.pos_points_delivery = store.pos_points_delivery == "true" 
                })
                commit("setItems", stores);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },

        async getFinancialData({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Store.getFinancialData(query);

                commit("setFinancialData", data.data.company[0].stores);
                commit("setServerItemsLength", data.data.pagination.total, {
                    root: true
                });
                commit("setServerPagination", data.data.pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },

        async create({ commit, state, rootState }) {
            try {
                commit("setLoading", true, { root: true });
                commit("setNewStoreCreated", false)

                let newStore = { ...state.store };
                let userDetails = { ...state.userDetails };

                delete newStore.store_id;
                delete newStore.bank_providers;
                delete newStore.registration_date
                newStore.parent_id = rootState.loyaltyPanel.company.store_id;

                userDetails.app_provider_id = rootState.user.app_provider_id;

                if (!userDetails.new_manager) {
                    userDetails.full_name = rootState.user.full_name;
                }

                state.userDetails;

                const { data } = await Store.create({
                    store_details: newStore,
                    user_details: userDetails
                });
                
                commit("addItem", data.data);
                commit("setNewStoreCreated", true)
                commit(
                    "setServerItemsLength",
                    rootState.serverItemsLength + 1,
                    { root: true }
                );
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created store!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async update({ commit, dispatch, state }, query) {
            try {
                commit("setLoading", true, { root: true });

                let updatingStore = { ...state.store };
                let updatingStoreId = updatingStore.store_id
                delete updatingStore.store_id;
                delete updatingStore.registration_date
                
                const { data } = await Store.update(updatingStore,updatingStoreId);

                dispatch("getItems", query)
                commit("updateItem", data.data.product, { root: true });
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated product!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async getStoresDefaultPermissions({ commit }) {
            try {
                const { data } = await Store.getStoresDefaultPermissions();
                commit("setStoresDefaultPermissions", data.data.default_store_cms);
            } catch (ex) {
                console.error(ex.response.data);
            }
        },

        async getStorePermissions({ commit }, store_id) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await Store.getStorePermissions(store_id);
                commit("setPermissions", data.data.cms_permissions);
                commit("setRightsDialog", true);
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
                return ex.response.data
            }
        },

        async updateDefaultPermissions({ commit, state, dispatch }) {
            try {
                commit("setLoading", true, { root: true });

                const permissions = state.permissions

                await Store.updateDefaultPermissions(permissions);

                dispatch("getStoresDefaultPermissions")

                commit("setLoading", false, { root: true });
                commit("setRightsDialog", false);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated store default permissions!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async updateStorePermissions({ commit, state }, id) {
            try {
                commit("setLoading", true, { root: true });

                const permissions = state.permissions

                await Store.updateStorePermissions(permissions, id);

                commit("setLoading", false, { root: true });
                commit("setRightsDialog", false);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated store permissions!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async toggleStoreValue({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                
                await Store.toggleStoreValue(body.store_id,body.payload);

                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully updated column value!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async remove({ commit, state, rootState }) {
            try {
                commit("setLoading", true, { root: true });

                await Store.delete(state.store.store_id);

                commit("removeItem", state.store.store_id);
                commit(
                    "setServerItemsLength",
                    rootState.serverItemsLength - 1,
                    { root: true }
                );
                commit("setLoading", false, { root: true });
                commit("setDeleteDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully deleted store!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },

        async getExportedFile({ commit }) {
            try {
                const data = await Store.getExportedFile()
                commit("setExportedFile", data.data.data)
            } catch (ex) {
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        
        async exportFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                const data = await Store.exportFile(body)
                commit("setExportedFile", data.data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });

                await Store.deleteExportedFile(id)
                commit("setExportedFile", null)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        }
    }
};
